import { ArticleTypeConstants } from '@article/constants/article-type-constants';

export const ConfiguratorParameters = {
  projectFileExtension: '.wsp',
  view: {
    orthographicLensFar: 50000,
    orthographicLensNear: -50000,
    mouseNavigationZoomSpeed: 1.0,
    mouseNavigationRotateSpeed: 9.4,
    mouseNavigationMoveSpeed: 1.0,
    cameraDefaultPan: 0,
    cameraDefaultTilt: 180,
    cameraDefaultDistance: 0.5,
    cameraDefaultDistancePdfCameraParameter: 2000,
    defaultViewMarginLeft: 230,
  },
  directPrintingColorToBackground: new Map<string, string>([
    ['black', "#FFFFFF"],
  ]),
  labeling: {
    defaultFontScale: 2.9,
    defaultLabelingFontName: 'smartFont',
    dinFontNameMiddle: 'din1451M',
    dinFontNameCondensed: 'din1451E',
    dinFontMiddleMaxCharacters: 3,

    /** Defined in feature 81897 */
    directPrintingFontSizes: new Map<string, number>([
      ["831", 10],
      ["2091", 4],
      ["2092", 5],
    ])
  },
  inverseTextureCoordinates: true,
  baseArticleTypes: ArticleTypeConstants.BASE_ARTICLE_TYPES,
  defaultArticleRepresentationName: 'MARKER_CARD',
  defaultViewMarginLeft: 230,
  // Allow closing a modal by clicking outside of it or pressing ESC
  allowClose: false,
  maxRendererAnisotropy: 1,
};

// Checks for din-font. Din fonts must always be plain (no styles like bold/italic/etc.)
export function isDinFont(fontName: string): boolean {
  return ConfiguratorParameters.labeling.dinFontNameMiddle === fontName
    || ConfiguratorParameters.labeling.dinFontNameCondensed === fontName;
}
